/* LOVE LACE — collection page: filters, sort, active chips, load more.
   Native Shopify storefront filtering + Section Rendering API.
   URL stays shareable/crawlable (pushState); Back/Forward work.
   Without JS the filter form and pagination are ordinary links/GET forms. */
(function () {
  'use strict';
  var doc = document, win = window;

  function init(root) {
    if (!root || root.__ll) return; root.__ll = true;
    var sid = root.getAttribute('data-section');
    var panel = root.querySelector('[data-ll-filters]');
    var overlay = root.querySelector('.ll-filters__overlay');
    var openBtn = root.querySelector('[data-ll-filter-open]');
    var busy = null, timer = null, lastFocus = null;
    var mqDesk = win.matchMedia('(min-width: 990px)');
    function isBar() { return mqDesk.matches && root.classList.contains('ll-coll--bar'); }
    function isDrawer() { return !(mqDesk.matches && (root.classList.contains('ll-coll--sidebar') || root.classList.contains('ll-coll--bar'))); }

    /* ---------- "Filter by" bar: pills open as dropdowns, one at a time ---------- */
    function closeDrops(except) {
      root.querySelectorAll('.ll-filters [data-ll-f][open]').forEach(function (d) { if (d !== except) d.open = false; });
    }
    if (isBar()) closeDrops();
    mqDesk.addEventListener && mqDesk.addEventListener('change', function () { if (isBar()) closeDrops(); });
    root.addEventListener('toggle', function (e) {
      var d = e.target;
      if (!isBar() || !d.matches || !d.matches('[data-ll-f]') || !d.open) return;
      closeDrops(d);
      var body = d.querySelector('.ll-f__body');
      if (body) { body.style.left = ''; body.style.right = ''; var r = body.getBoundingClientRect(); if (r.right > win.innerWidth - 12) { body.style.left = 'auto'; body.style.right = '0'; } }
    }, true);
    doc.addEventListener('click', function (e) { if (isBar() && !e.target.closest('.ll-filters [data-ll-f]')) closeDrops(); });

    /* ---------- drawer ---------- */
    function openPanel() {
      if (!isDrawer()) { panel.scrollIntoView({ behavior: 'smooth', block: 'start' }); return; }
      lastFocus = doc.activeElement;
      root.classList.add('is-filters-open'); doc.documentElement.classList.add('ll-lock');
      if (overlay) overlay.hidden = false;
      openBtn.setAttribute('aria-expanded', 'true');
      var f = panel.querySelector('.ll-filters__close'); if (f) f.focus();
    }
    function closePanel() {
      if (!root.classList.contains('is-filters-open')) return;
      root.classList.remove('is-filters-open'); doc.documentElement.classList.remove('ll-lock');
      if (overlay) overlay.hidden = true;
      openBtn.setAttribute('aria-expanded', 'false');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-ll-filter-open]')) { e.preventDefault(); openPanel(); }
      else if (e.target.closest('[data-ll-filter-close]')) { e.preventDefault(); closePanel(); }
    });
    doc.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        closePanel();
        if (isBar()) { var o = root.querySelector('.ll-filters [data-ll-f][open]'); if (o) { closeDrops(); var sm = o.querySelector('summary'); if (sm) sm.focus(); } }
      }
      if (e.key === 'Tab' && root.classList.contains('is-filters-open')) {
        var els = panel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), summary, select');
        if (!els.length) return;
        var first = els[0], last = els[els.length - 1];
        if (e.shiftKey && doc.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && doc.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });

    /* ---------- fetch + swap ---------- */
    function sectionUrl(url) {
      var u = new URL(url, win.location.origin);
      u.searchParams.set('section_id', sid);
      return u.toString();
    }
    function cleanUrl(url) {
      var u = new URL(url, win.location.origin);
      u.searchParams.delete('section_id'); u.searchParams.delete('page');
      return u.pathname + (u.search ? u.search : '');
    }
    function openState() {
      var st = {};
      root.querySelectorAll('[data-ll-f]').forEach(function (d) { st[d.getAttribute('data-ll-f')] = d.open; });
      return st;
    }
    function swap(html, keepOpen) {
      var tmp = doc.createElement('div'); tmp.innerHTML = html;
      var fresh = tmp.querySelector('[data-ll-coll]');
      if (!fresh) return;
      var focusId = doc.activeElement && root.contains(doc.activeElement) ? doc.activeElement.id : null;
      var st = openState();
      ['[data-ll-results]', '[data-ll-active]', '[data-ll-count]', '[data-ll-filters-body]', '[data-ll-apply-count]', '[data-ll-sort-form]'].forEach(function (sel) {
        var a = root.querySelector(sel), b = fresh.querySelector(sel);
        if (a && b) a.innerHTML = b.innerHTML;
      });
      var badgeA = root.querySelector('[data-ll-active-count]'), badgeB = fresh.querySelector('[data-ll-active-count]');
      if (badgeA && badgeB) { badgeA.textContent = badgeB.textContent; badgeA.hidden = badgeB.hidden; }
      var applyA = root.querySelector('[data-ll-filter-apply]'), applyB = fresh.querySelector('[data-ll-filter-apply]');
      if (applyA && applyB) applyA.innerHTML = applyB.innerHTML;
      if (keepOpen) root.querySelectorAll('[data-ll-f]').forEach(function (d) { var k = d.getAttribute('data-ll-f'); if (k in st) d.open = st[k]; });
      if (isBar()) root.querySelectorAll('[data-ll-f]').forEach(function (d) { d.open = !!st[d.getAttribute('data-ll-f')]; });
      if (focusId) { var el = doc.getElementById(focusId); if (el) el.focus({ preventScroll: true }); }
      applyView();
      if (win.LoveLaceStory) win.LoveLaceStory.dedupe(root);
    }
    function load(url, push) {
      if (busy) busy.abort();
      busy = ('AbortController' in win) ? new AbortController() : null;
      root.classList.add('is-loading');
      return fetch(sectionUrl(url), { credentials: 'same-origin', signal: busy ? busy.signal : undefined })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          swap(html, true);
          var clean = cleanUrl(url);
          if (push) history.pushState({ ll: true }, '', clean);
          doc.dispatchEvent(new CustomEvent('ll:filter', { detail: { type: push === 'sort' ? 'sort' : 'filter', query: (clean.split('?')[1] || '').slice(0, 300), count: (root.querySelector('[data-ll-count]') || {}).textContent } }));
        })
        .catch(function (e) { if (!e || e.name !== 'AbortError') win.location.href = url; })
        .finally(function () { root.classList.remove('is-loading'); });
    }
    function formUrl(form) {
      var fd = new FormData(form), p = new URLSearchParams();
      fd.forEach(function (v, k) { if (v !== '' && v != null) p.append(k, v); });
      var q = p.toString();
      return form.getAttribute('action') + (q ? '?' + q : '');
    }

    /* filter form: live update */
    root.addEventListener('change', function (e) {
      var form = e.target.form;
      if (!form) return;
      if (form.hasAttribute('data-ll-filter-form')) {
        if (e.target.name === 'sort_by' && isBar()) closeDrops();
        clearTimeout(timer);
        var wait = e.target.type === 'number' ? 500 : 60;
        timer = setTimeout(function () { load(formUrl(form), e.target.name === 'sort_by' ? 'sort' : true); }, wait);
      } else if (form.hasAttribute('data-ll-sort-form')) {
        var radio = root.querySelector('[data-ll-filter-form] input[name="sort_by"][value="' + e.target.value + '"]');
        if (radio) radio.checked = true;
        load(formUrl(form), 'sort');
      }
    });
    root.addEventListener('input', function (e) {
      if (e.target.type !== 'number' || !e.target.form) return;
      clearTimeout(timer);
      var form = e.target.form;
      timer = setTimeout(function () { load(formUrl(form), true); }, 700);
    });
    root.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.hasAttribute('data-ll-filter-form') && !form.hasAttribute('data-ll-sort-form')) return;
      e.preventDefault();
      if (form.hasAttribute('data-ll-filter-form') && root.classList.contains('is-filters-open')) { closePanel(); return; }
      load(formUrl(form), true);
    });
    /* price presets */
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-ll-price]');
      if (!b) return;
      var box = b.closest('.ll-f');
      var r = b.getAttribute('data-ll-price').split('-');
      var mn = box.querySelector('[data-ll-min]'), mx = box.querySelector('[data-ll-max]');
      if (mn) mn.value = r[0] || ''; if (mx) mx.value = r[1] || '';
      load(formUrl(b.closest('form')), true);
    });
    /* chips, clear all, pagination links */
    root.addEventListener('click', function (e) {
      var a = e.target.closest('[data-ll-filter-link], .ll-pager a');
      if (!a || e.metaKey || e.ctrlKey) return;
      e.preventDefault();
      var toTop = a.closest('.ll-pager');
      load(a.href, !toTop).then(function () { if (toTop) (isBar() ? panel : root.querySelector('[data-ll-bar]')).scrollIntoView({ behavior: 'smooth' }); });
    });
    /* load more */
    root.addEventListener('click', function (e) {
      var a = e.target.closest('[data-ll-load-more]');
      if (!a) return;
      e.preventDefault();
      a.classList.add('is-loading'); a.setAttribute('aria-busy', 'true');
      fetch(sectionUrl(a.href), { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
        var tmp = doc.createElement('div'); tmp.innerHTML = html;
        var grid = root.querySelector('[data-ll-grid]'), items = tmp.querySelectorAll('[data-ll-grid] > li');
        var firstNew = null;
        items.forEach(function (li) { if (!firstNew) firstNew = li; grid.appendChild(li); });
        var footA = root.querySelector('.ll-coll__foot'), footB = tmp.querySelector('.ll-coll__foot');
        if (footA && footB) footA.innerHTML = footB.innerHTML;
        if (firstNew) { var l = firstNew.querySelector('a[href]:not([tabindex="-1"])'); if (l) l.focus({ preventScroll: true }); }
        if (win.LoveLaceStory) win.LoveLaceStory.dedupe(root);
      }).catch(function () { win.location.href = a.href; });
    });
    win.addEventListener('popstate', function () { load(win.location.href, false); });

    /* ---------- grid view (desktop) ---------- */
    var view = '4';
    try { view = localStorage.getItem('ll-grid-view') || '4'; } catch (e) {}
    function applyView() {
      var g = root.querySelector('[data-ll-grid]');
      if (g) { g.classList.toggle('is-list', view === 'list'); g.style.setProperty('--cols', view === 'list' ? 1 : view); }
      root.querySelectorAll('[data-ll-view]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-ll-view') === view ? 'true' : 'false'); });
    }
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-ll-view]');
      if (!b) return;
      view = b.getAttribute('data-ll-view');
      try { localStorage.setItem('ll-grid-view', view); } catch (err) {}
      applyView();
    });
    applyView();

    /* ---------- description clamp ---------- */
    var clamp = root.querySelector('[data-ll-clamp]');
    if (clamp) {
      var txt = clamp.querySelector('.ll-coll__desc-text'), tg = clamp.querySelector('[data-ll-clamp-toggle]');
      if (txt.scrollHeight > txt.clientHeight + 4) tg.hidden = false;
      tg.addEventListener('click', function () {
        var open = clamp.classList.toggle('is-open');
        tg.setAttribute('aria-expanded', open ? 'true' : 'false');
        tg.textContent = open ? 'Read less' : 'Read more';
      });
    }

    /* ---------- sticky bar state ---------- */
    var bar = root.querySelector('[data-ll-bar]');
    if (bar && 'IntersectionObserver' in win) {
      var sentinel = doc.createElement('div'); sentinel.style.height = '1px'; bar.parentNode.insertBefore(sentinel, bar);
      new IntersectionObserver(function (es) { bar.classList.toggle('is-stuck', !es[0].isIntersecting); }, { rootMargin: '-80px 0px 0px 0px' }).observe(sentinel);
    }
  }

  function boot(scope) { (scope || doc).querySelectorAll('[data-ll-coll]').forEach(init); }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', function () { boot(); }); else boot();
  doc.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
